import { Button, Input, notification } from "antd";
import React from "react";
import api from "../../../../../../services/api";
import { isSuperUser } from "../../../../../../utils/is-superuser";

export function NumeroClienteField({ acordoId, value }) {
  const [isEditing, setEditing] = React.useState(false);
  const [isSaving, setSaving] = React.useState(false);
  const [inputValue, setInputValue] = React.useState(value);

  const toggleEdit = () => setEditing(!isEditing);

  const handleSave = () => {
    // save new value
    setSaving(true);

    api
      .post("/acordo/update-numero-cliente/", {
        acordo_id: acordoId,
        numero_cliente: inputValue
      })
      .then(() => {
        setEditing(false);
        setSaving(false);
        notification.success({
          message: "Número cliente atualizado com sucesso."
        });
      })
      .catch(() => {
        setSaving(false);
        notification.error({
          message: "Falha ao salvar número cliente"
        });
      });
  };

  const handleInputChange = event => setInputValue(event.target.value);
  const isAdmin = isSuperUser();

  return (
    <div
      style={{
        display: "flex",
        gap: "5px"
      }}
    >
      <Input
        disabled={!isEditing}
        placeholder="Vazio"
        onChange={handleInputChange}
        value={inputValue}
      />
      {isAdmin && (
        <React.Fragment>
          {isEditing ? (
            <Button
              type="primary"
              title="Salvar"
              onClick={handleSave}
              disabled={isSaving}
            >
              Salvar
            </Button>
          ) : (
            <Button
              icon="edit"
              type="primary"
              title="Editar"
              onClick={toggleEdit}
            />
          )}
        </React.Fragment>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/Acordo/View/AcordoView/AcordoInfos/NumeroClienteField/index.jsx